<template>
  <div class="cm-select">
    <span
      class="cm-select__choice"
      :class="isOpen && !disabled ? 'cm-select__choice--opened' : 'cm-select__choice--closed'"
      @click="isOpen = !isOpen"
    >
      {{ value.label }}
    </span>
    <div
      v-if="isOpen && !disabled"
      class="cm-select__options-container"
      v-click-outside="() => isOpen = false"
    >
      <span
        v-for="(item, index) in options"
        :key="index"
        class="cm-select__option"
        :class="{'cm-select__option--active': value.id === item.id}"
        @click="selectOption(item)"
      >
        {{ item.label }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CmSelect",

  props: {
    value: {
    },
    options: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpen: false
    }
  },

  methods: {
    selectOption(opt) {
      this.$emit("input", opt);
      this.isOpen = false;
    }
  }
}
</script>

<style lang="scss">
.cm-select {
  width: 219px;
  position: relative;
  &__choice {
    background: $color_white;
    border: 1px solid #a7a7a7;
    border-radius: 3px;
    box-sizing: border-box;
    display: block;
    color: $color_black;
    position: relative;
    padding: 9px 36px 9px 14px;
    line-height: 100%;
    width: 100%;
    height: 35px;
    cursor: pointer;
    @include overflow-ellipsis();
    &:after {
      content: "";
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      width: 0;
      height: 0;
      position: absolute;
      right: 14px;
    }
    &--closed {
      &:after {
        border-top: 6px solid #afafaf;
        top: 15px;
      }
    }
    &--opened {
      &:after {
        border-bottom: 6px solid #afafaf;
        top: 12px;
      }
    }
  }
  &__options-container {
    background: $color_white;
    border: 1px solid #a7a7a7;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    position: absolute;
    top: 45px;
    left: 0;
    right: 0;
    max-width: 100%;
    z-index: 999;
  }
  &__option {
    display: block;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 9px 14px;
    color: $color_black;
    &:not(:last-child) {
      border-bottom: 1px solid rgba(167, 167, 167, 0.25);
    }
    &--active {
      font-weight: 600;
      pointer-events: none;
    }
    &:hover {
      color: $color_green;
    }
  }
  .disabled {
    cursor: not-allowed;
  }
}
</style>
